// Read metadata describes the decoded value, not the SQL storage kind: mysql2
// represents SQL NULL and JSON null alike. Unchanged values are never rewritten.
export const readOptionsState = (value, state) => {
  if (['null', 'missing', 'list', 'legacy'].includes(state)) return state;
  if (value === null) return 'null';
  if (value === undefined) return 'missing';
  return Array.isArray(value) ? 'list' : 'legacy';
};

export const optionsPayload = (editor) => (
  editor.optionsDirty === false || !Object.prototype.hasOwnProperty.call(editor, 'options')
    ? {}
    : { options: editor.options }
);
